import React from "react";
import { Button } from "@mui/material";
import { TailwindModal } from "../components";
import { useStore } from "../helpers";
import { observer } from "mobx-react-lite";
import ImageCapture from "../new-features/service-requests/sr-components/image-capture";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { PerformingFaceMatch } from "./performing-face-match";
import { VoterNotFound } from "../components/voter-not-found";
import { ServerError } from "../components/server-error";
import { ScannedProfile } from "../new-features/service-requests/sr-components/scanned-profile";
import { ScanFace } from "lucide-react";
import { MultipleFaceDetect } from "./multiple-face-detect";
import { useTranslation } from "react-i18next";

export const FetchFromFacialRecognitionButton = observer(() => {
    const { aiGentoolStore } = useStore();
    const { add_face_modal } = aiGentoolStore;
    const { t } = useTranslation("fetchFromFacialRecognition");

    const handleOpen = () => {
        aiGentoolStore.update_add_face_modal(true);
        aiGentoolStore.update_show_scanned_voter(false);
    };

    const handleClose = () => {
        aiGentoolStore.update_add_face_modal(false);
    };

    // const handleImageCapture = () => {
    //   aiGentoolStore.update_add_face_modal(false);
    //   aiGentoolStore.toggle_image_capture_modal(true);
    // };

    const handleImageCapture = () => {
        aiGentoolStore.update_add_face_modal(false);

        aiGentoolStore.setImageCaptureMode("faceRecognition");
        aiGentoolStore.setVoterPhotoVoterId("");
        aiGentoolStore.setVoterPhotoS3Path(null);

        aiGentoolStore.toggle_image_capture_modal(true);
    };
    return (
        <div className="mt-8">
            <Button
                variant="outlined"
                sx={{ backgroundColor: "white" }}
                startIcon={<ScanFace />}
                onClick={handleOpen}
            >
                {t("fetch_facial")}
            </Button>

            <TailwindModal isOpen={add_face_modal}>
                <div className="mx-auto flex h-[85vh] w-full max-w-4xl flex-col items-center rounded-2xl bg-common-white p-4">
                    <div className="mb-6 flex w-full items-center justify-between">
                        <h2 className="text-lg font-semibold text-gray-800">{t("facial_recognition")}</h2>
                        <button onClick={handleClose} className="text-xl text-gray-500 hover:text-gray-700">
                            ✕
                        </button>
                    </div>

                    <div className="flex h-[85vh] w-full flex-col items-center justify-center rounded-2xl bg-gray-100 p-12">
                        <div className="relative mb-8 flex items-center justify-center">
                            <div className="absolute left-[-70px] flex h-28 w-28 rotate-[-10deg] items-center justify-center rounded-xl bg-white shadow-md">
                                <DotLottieReact
                                    src="https://lottie.host/26217fb7-c66b-439f-9d68-8398b71cf669/T7I7T0vAEf.lottie"
                                    loop
                                    autoplay
                                />
                            </div>

                            <div className="z-10 flex h-36 w-36 items-center justify-center rounded-xl border-2 bg-white shadow-xl">
                                <DotLottieReact
                                    src="https://lottie.host/26217fb7-c66b-439f-9d68-8398b71cf669/T7I7T0vAEf.lottie"
                                    loop
                                    autoplay
                                />
                            </div>

                            <div className="absolute right-[-70px] flex h-28 w-28 rotate-[10deg] items-center justify-center rounded-xl bg-white shadow-md">
                                <DotLottieReact
                                    src="https://lottie.host/26217fb7-c66b-439f-9d68-8398b71cf669/T7I7T0vAEf.lottie"
                                    loop
                                    autoplay
                                />
                            </div>
                        </div>

                        <p className="mb-2 text-center text-sm font-medium text-gray-500">
                            {t("capture_voter")}
                        </p>
                        <p className="mb-6 text-center text-base font-medium text-gray-800">
                            {t("ask_voter")} <br />
                            {t("ensure_better")}
                        </p>
                        <button
                            className="rounded-lg border border-[#6D4DFF] px-8 py-2 font-medium text-[#6D4DFF] transition-all duration-300 ease-in-out hover:bg-gradient-to-r hover:from-[#6D4DFF] hover:to-[#3A80F4] hover:text-white"
                            onClick={handleImageCapture}
                        >
                            {t("open_camera")}
                        </button>
                    </div>
                </div>
            </TailwindModal>
            {aiGentoolStore.image_capture_modal && <ImageCapture />}
            <PerformingFaceMatch />
            <VoterNotFound />
            <ServerError />
            <ScannedProfile />
            <MultipleFaceDetect />
        </div>
    );
});
